import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initializeAnalytics, trackPageView } from "../utils/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    initializeAnalytics();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (previousPath.current === path) return;

    previousPath.current = path;
    trackPageView(path);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
